"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("react-day-picker/lib/style.css");
var react_1 = tslib_1.__importStar(require("react"));
var DayPickerInput_1 = tslib_1.__importDefault(require("react-day-picker/DayPickerInput"));
var moment_1 = tslib_1.__importDefault(require("react-day-picker/moment"));
var MaskedTextInput_1 = require("../MaskedTextInput");
var Icon_1 = require("../Icon");
var icons_1 = require("../../icons");
var DatePickerWrapper_1 = tslib_1.__importDefault(require("./DatePickerWrapper"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var moment_2 = tslib_1.__importDefault(require("moment"));
var IconWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var DatePicker = function (_a) {
    var _b = _a.dateFormat, dateFormat = _b === void 0 ? 'DD/MM/YYYY' : _b, _c = _a.hideTodayButton, hideTodayButton = _c === void 0 ? false : _c, onDayPickerShow = _a.onDayPickerShow, onDayPickerHide = _a.onDayPickerHide, value = _a.value, _d = _a.fixedWeeks, fixedWeeks = _d === void 0 ? true : _d, disabledDays = _a.disabledDays, props = tslib_1.__rest(_a, ["dateFormat", "hideTodayButton", "onDayPickerShow", "onDayPickerHide", "value", "fixedWeeks", "disabledDays"]);
    var datePickerInputRef = react_1.createRef();
    var handleIconClick = function () {
        if (datePickerInputRef.current) {
            datePickerInputRef.current.showDayPicker();
        }
    };
    var handlePickDay = function (day) {
        var onChange = props.onChange, name = props.name;
        if (day && onChange) {
            onChange({ target: { value: moment_2.default(day).format(dateFormat), name: name } });
        }
    };
    return (react_1.default.createElement(DatePickerWrapper_1.default, null,
        react_1.default.createElement(DayPickerInput_1.default, { ref: datePickerInputRef, format: dateFormat, formatDate: moment_1.default.formatDate, parseDate: moment_1.default.parseDate, placeholder: dateFormat, dayPickerProps: tslib_1.__assign({ fixedWeeks: fixedWeeks,
                disabledDays: disabledDays }, (hideTodayButton
                ? {}
                : {
                    showOutsideDays: true,
                    todayButton: 'Today'
                })), onDayPickerShow: onDayPickerShow, onDayPickerHide: onDayPickerHide, onDayChange: handlePickDay, component: MaskedTextInput_1.MaskedTextInput, value: value, inputProps: tslib_1.__assign(tslib_1.__assign({}, props), { autoComplete: 'off', options: {
                    date: true,
                    datePattern: ['d', 'm', 'Y']
                }, inputIcon: (react_1.default.createElement(IconWrapper, { onClick: handleIconClick, role: "button" },
                    react_1.default.createElement(Icon_1.Icon, { icon: icons_1.Calendar, id: "calendar-icon-button", width: "24px", height: "24px" }))), 'data-testid': 'calendar-icon' }) })));
};
exports.default = DatePicker;
var templateObject_1;
//# sourceMappingURL=DatePicker.js.map